export default __webpack_public_path__ + "static/media/clients.e6ca6a4b.svg";